module.exports = __webpack_public_path__ + "static/media/pesticide.332e2d14.png";